export const environment = {
  production: false,

  buildDate: '09/08/2024',

  authorizationKey: 'GoyBKWuIr8aqKKThRjA5',

  // serverBaseUrl: 'http://localhost:8080/evisaBackend/',
  serverBaseUrl: 'https://evisa.swglobalstaging.com/app/evisa/',

  // serverBaseUrl: 'https://evisa.immigration.gov.ng/evisa/',


  keycloakUrl: 'https://auth.swglobalstaging.com/auth/',

  keycloakRealm: 'immigration',

  keycloakClientId: 'immigration_auth',

  keycloakRedirectUrl: 'https://evisa.swglobalstaging.com/',

  domain: 'evisa.swglobalstaging.com',


  // keycloakRedirectUrl: 'http://localhost:4200/',

  // domain: 'localhost',

  path: '/',

  isEnableAdminConfig: true,

  isEnableIOSV2: false,

  raveMerchant: 'EVISA_WEB',

  raveService: 'EVISA_WEB',

  raveKey: 'N^KBUW4N&7TA4D',

  // raveUrl: 'https://ravestaging.newworkssolution.com',
  // raveKey: 'A@ZHVY$^8H$5LG',

  // raveUrl: 'https://rave.newworkssolution.com',

  hashBaseUrl: "https://cpayment.swglobalstaging.com/api/",

  refundPolicyUrl: 'https://immigration.gov.ng/refundpolicy/'

};
